import { type JSX, useState } from 'react';
import classnames from '@common/utils/ui/classnames';
import '@common/styles/components/dynamicImage.pcss';

type DynamicImageProps =
  & Pick<HTMLImageElement, 'alt' | 'src'>
  & Partial<Pick<HTMLImageElement, 'height'>>
  & {
    placeholder: JSX.Element | string;
    dropShadow?: boolean;
    lessContrast?: boolean;
    fitContent?: boolean;
  };

function DynamicImage({
  placeholder,
  alt,
  src,
  height,
  dropShadow = false,
  lessContrast,
  fitContent,
}: DynamicImageProps) {
  const [loadingState, setLoadingState] = useState<undefined | 'done' | 'error'>();
  return (
    <span
      className={classnames({
        'dynamic-image': true,
        'dynamic-image--error': loadingState === 'error',
        'dynamic-image--loaded': loadingState === 'done',
        'dynamic-image--with-shadow': dropShadow,
        'dynamic-image--with-less-contrast': lessContrast,
        'dynamic-image--fit-content': fitContent,
      })}
    >
      <img
        className="dynamic-image__image"
        onLoad={() => setLoadingState('done')}
        onError={() => setLoadingState('error')}
        src={src}
        alt={alt}
        height={height}
      />
      <span
        className="dynamic-image__placeholder"
        style={height ? { height: `${height}px` } : undefined}
      >
        {placeholder}
      </span>
    </span>
  );
}

export default DynamicImage;
